export default "/wp-content/themes/onnit/script/cart/dist/vtiOverrideMobile-a165aac1.png";